import { createContext, useContext } from "react";
import { MastersState } from "src/pages/AppTheme/Types";

type AppThemeContextType = {
  updateGenericData: (type: string, key: string, value: any) => Promise<boolean>;
  updateGenericColor: (key: string, category: string, hexColor: string, alpha: number) => Promise<boolean>;
  updateFontData: (key: string, family?: string, size?: number, colour?: string, weight?: string, alpha?: number) => Promise<boolean>;
  updateIconData: (key: string, icon?: string, size?: number, colour?: string, type?: string, alpha?: number) => Promise<boolean>;
  masterOptions: MastersState;
};

export const AppThemeContext = createContext<AppThemeContextType | undefined>(undefined);

export const useAppThemeContext = () => {
  const context = useContext(AppThemeContext);
  if (!context) {
    throw new Error("useAppThemeContext must be used within AppThemeProvider");
  }
  return context;
};
